// The owner's result: won, drawn or lost.
import { ownerOutcome } from '../classify.ts';
import { oneOf, type FilterCriterion } from '../criterion.ts';
import { GAME_OUTCOMES } from '@chess/api-model';

export const outcome: FilterCriterion<'outcome'> = {
  key: 'outcome',
  query: 'result',
  many: true,
  parse: oneOf(GAME_OUTCOMES),
  format: (v) => v,
  matches: (game, v) => ownerOutcome(game) === v,
  control: { kind: 'choice', order: 10, label: 'Result', options: [['win', 'Won'], ['draw', 'Drawn'], ['loss', 'Lost']] },
};
